import { getOperatorCashier, openCashier } from "../api/cashier";
import {
  setCashier,
  setShowNewCashierModal,
} from "../store/actions/cashierSlice";
import store from "../store/store";
import { dispatchSnackBarMessage } from "./snackbar";

// Returns true when an open cashier was found, false when the server says
// there is none (404), and null when the lookup itself failed. Callers must
// only offer to open a new cashier on false: a timeout is not "no cashier".
export const getUserOpenCashier = async (params = undefined) => {
  try {
    const { data } = await getOperatorCashier(params);

    if (!data) {
      if (store.getState().auth.user?.user_type) {
        store.dispatch(setShowNewCashierModal(true));
      }
      return false;
    }

    store.dispatch(setCashier(data));

    return true;
  } catch (e) {
    if (e.response?.status === 404) {
      store.dispatch(setCashier(null));
      return false;
    }
    return null;
  }
};

export const openUserOpenCashier = async ({ start_value_cents, type }) => {
  try {
    const { data } = await openCashier({
      start_value_cents: start_value_cents,
      type,
    });

    if (!data) {
      if (store.getState().auth.user?.user_type) {
        store.dispatch(setShowNewCashierModal(true));
      }
      return false;
    }

    store.dispatch(setCashier(data));
    store.dispatch(setShowNewCashierModal(false));

    return true;
  } catch (e) {
    console.error(e);

    // The usual refusal is that a cashier is already open for this operation
    // (opened on another device, or this screen is stale). Load it instead of
    // leaving the operator clicking a button that silently does nothing.
    if (await getUserOpenCashier()) {
      store.dispatch(setShowNewCashierModal(false));
      dispatchSnackBarMessage(
        `cashier-already-open-${Date.now()}`,
        "Já existe um caixa aberto. Ele foi carregado.",
        "info"
      );
      return true;
    }

    dispatchSnackBarMessage(
      `cashier-open-error-${Date.now()}`,
      e.response?.data?.error
        ? `Não foi possível abrir o caixa: ${e.response.data.error}`
        : "Não foi possível abrir o caixa. Verifique a conexão e tente novamente.",
      "error"
    );
    return false;
  }
};

export const cashierTransactionTypeFilter = (type) => {
  switch (type) {
    case 1:
      return "Reforço";

    case 2:
      return "Retirada";

    case 3:
      return "Pendência";

    default:
      return type;
  }
};
